import { create } from 'zustand'

interface AuthUiState {
  isRequestPasswordResetModalOpen: boolean
  openRequestPasswordResetModal: () => void
  closeRequestPasswordResetModal: () => void
  isExpiredPasswordModalOpen: boolean
  openExpiredPasswordModal: () => void
  closeExpiredPasswordModal: () => void
}

export const useAuthUiStore = create<AuthUiState>(set => ({
  isRequestPasswordResetModalOpen: false,
  openRequestPasswordResetModal: () =>
    set({ isRequestPasswordResetModalOpen: true }),
  closeRequestPasswordResetModal: () =>
    set({ isRequestPasswordResetModalOpen: false }),
  isExpiredPasswordModalOpen: false,
  openExpiredPasswordModal: () => set({ isExpiredPasswordModalOpen: true }),
  closeExpiredPasswordModal: () => set({ isExpiredPasswordModalOpen: false }),
}))
